import { datadogRum } from '@datadog/browser-rum'

type MonitorArgs<T> = {
  operationName: string
  variables?: T
  request: () => Promise<unknown>
}

export async function monitorGraphqlOperation<
  TVars extends Record<string, unknown> | undefined,
>({ operationName, variables, request }: MonitorArgs<TVars>) {
  const start = performance.now()

  try {
    const result = await request()

    const durationMs = performance.now() - start

    datadogRum.addAction('graphql.operation', {
      operationName,
      ok: true,
      durationMs: Math.round(durationMs),
      variablesKeys: variables ? Object.keys(variables) : [],
    })

    return result
  } catch (err) {
    const durationMs = performance.now() - start

    datadogRum.addAction('graphql.operation', {
      operationName,
      ok: false,
      durationMs: Math.round(durationMs),
      errorType: err instanceof Error ? err.name : 'UnknownError',
    })

    datadogRum.addError(err, {
      operationName,
      source: 'graphql',
    })

    throw err
  }
}
